export default {

    /**
     * 复制对象（无法复制函数）
     *
     * @param obj
     * @returns {any}
     */
    copy(obj){
        return JSON.parse(JSON.stringify(obj));
    }

}
